module.exports = __webpack_public_path__ + "static/corp-d68863b4a122d622b5bb8f4c84067849.mp4";